import { getReq } from '../config/http'

// 检查链接有效性
export const checkLink = id => getReq(`/lc/link/linkCheck?tUid=${id}`)
